module.exports = __webpack_public_path__ + "static/img/jiaoyijiufen.7fef363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/jiaoyijiufen.jpg
// module id = 1415
// module chunks = 1